// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2KNEC","col":"Table_col__1oEei","fulfillmentStatus":"Table_fulfillmentStatus__4eTeR","emailCol":"Table_emailCol__2kaog"};